import { Box, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import cx from 'classnames'
import React, { ReactNode } from 'react'
import IndicatorTooltip from './IndicatorTooltip'

const INDICATOR_CHIP_SIZE = 32
const GLYPH_SIZE = 18
const CHIP_PADDING = (INDICATOR_CHIP_SIZE - GLYPH_SIZE) / 2

type Props = {
  children: ReactNode
  tooltip: string
  label?: string
  color?: string
  testId?: string
}

const useStyles = makeStyles((theme) => ({
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    boxSizing: 'border-box',
    height: INDICATOR_CHIP_SIZE,
    padding: CHIP_PADDING,
    borderRadius: INDICATOR_CHIP_SIZE / 2,
    flexShrink: 0,
  },
  neutralChip: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.darkestGreen,
  },
  glyph: {
    display: 'flex',
    flexShrink: 0,
    width: GLYPH_SIZE,
    height: GLYPH_SIZE,
    '& > *': {
      width: '100%',
      height: '100%',
    },
  },
  label: {
    padding: theme.spacing(0, 0.25),
    whiteSpace: 'nowrap',
  },
}))

const IndicatorChip = ({ children, tooltip, label, color, testId }: Props) => {
  const styles = useStyles()

  return (
    <IndicatorTooltip title={tooltip}>
      <Box
        className={cx(styles.chip, { [styles.neutralChip]: !color })}
        bgcolor={color}
        color={color ? 'common.white' : undefined}
        data-testid={testId}
        role="img"
        aria-label={tooltip}
      >
        <Box className={styles.glyph}>{children}</Box>
        {label && (
          <Typography variant="subtitle2" component="span" className={styles.label}>
            {label}
          </Typography>
        )}
      </Box>
    </IndicatorTooltip>
  )
}

export default IndicatorChip
